import { useConfig } from "components/ui";

function useThemeClass() {
  const { themeColor, primaryColorLevel } = useConfig();

  // Safety fallback for legacy or invalid theme colors
  const safeThemeColor = (themeColor.includes("#") || !themeColor) ? "indigo" : themeColor;

  const isCustom = safeThemeColor.includes("#-");
  const color = isCustom
    ? `${safeThemeColor}`
    : `${safeThemeColor}-${primaryColorLevel}`;

  return {
    ringTheme: `ring-${color}`,
    borderTheme: `border-${color}`,
    bgTheme: `bg-${color}`,
    textTheme: `text-${color}`,
    themeColorAndLevel: color,
  };
}

export default useThemeClass;
